<template>
  <div>
    <div>
      <div>
        <h1 class="h2 mt-4">Biztosított adatai</h1>
        <div v-if="nsuMiner">
          <!-- <div class="row">
            <ValidationProvider rules="required" v-slot="{errors}" class="col-md-6 mb-3">
              <div class="input-group">
                <div class="input-group-prepend">
                  <span class="input-group-text" id="gender_prepend"
                    ><label for="gender">Biztosított neme:</label>
                    <span class="text-danger">*</span></span
                  >
                </div>
                <select
                  class="form-select dark-border"
                  id="gender"
                  name="gender"
                  v-model="insuredGender"
                  required
                >
                  <option value="" selected disabled>Kérem, válasszon!</option>
                  <option value="male">Férfi</option>
                  <option value="female">Nő</option>
                  <option value="other">Más/Nem kívánok választani</option>
                </select>
                <small class="text-danger input-alert">{{ errors[0] }}</small>
              </div>
              <small id="gender-error" class="text-danger input-alert">{{
                errors[0]
              }}</small>
            </ValidationProvider>
          </div> -->
          <div class="row">
            <ValidationProvider rules="required" v-slot="{errors, classes}" class="col-md-6 mb-3">
              <div class="input-group">
                <div class="input-group-prepend dark-border">
                  <span class="input-group-text" id="ins_lastname_prepend"
                    ><label for="ins_lastname">Vezetéknév:</label>
                    <span class="text-danger">*</span></span
                  >
                </div>
                <input
                  type="text"
                  class="form-control dark-border"
                  id="ins_lastname"
                  name="ins_lastname"
                  v-model="insuredLastName"
                  aria-label="Biztositott Vezetéknév"
                  :class="classes"
                />
              </div>
              <small id="ins_lastname-error" class="text-danger input-alert">{{ errors[0] }}</small>
            </ValidationProvider>
            <ValidationProvider rules="required" v-slot="{errors, classes}" class="col-md-6 mb-3">
              <div class="input-group">
                <div class="input-group-prepend dark-border">
                  <span class="input-group-text" id="ins_firstname_prepend"
                    ><label for="ins_firstname">Keresztnév:</label>
                    <span class="text-danger">*</span></span
                  >
                </div>
                <input
                  type="text"
                  class="form-control dark-border"
                  id="ins_firstname"
                  name="ins_firstname"
                  v-model="insuredFirstName"
                  aria-label="Biztositott Keresztnév"
                  :class="classes"
                />
              </div>
              <small id="ins_firstname-error" class="text-danger input-alert">{{
                errors[0]
              }}</small>
            </ValidationProvider>
          </div>
          <div class="row">
            <ValidationProvider rules="required" v-slot="{errors, classes}" class="col-md-6 mb-3">
              <div class="input-group">
                <div class="input-group-prepend dark-border">
                  <span class="input-group-text" id="ins_mothersname_prepend"
                    ><label for="ins_mothersname">Biztositott anyjának leánykori neve:</label>
                    <span class="text-danger">*</span></span
                  >
                </div>
                <input
                  type="text"
                  class="form-control dark-border"
                  id="ins_mothersname"
                  name="ins_mothersname"
                  v-model="insuredMotherChildName"
                  aria-label="Biztositott Anyjanak leánykori neve"
                  :class="classes"
                />
              </div>
              <small id="ins_mothersname-error" class="text-danger input-alert">{{
                errors[0]
              }}</small>
            </ValidationProvider>
            <!-- <div class="col-md-6 mb-3">
              <div class="input-group">
                <div class="input-group-prepend">
                  <span class="input-group-text" id="biztositott_szuletes_nev_prepend"
                    ><label for="biztositott_szuletes_nev"
                      >Születéskori neve:</label
                    ></span
                  >
                </div>
                <input
                  type="text"
                  class="form-control dark-border"
                  id="biztositott_szuletes_nev"
                  name="biztositott_szuletes_nev"
                  v-model="insuredBornName"
                  aria-label="Keresztnév"
                  aria-describedby="biztositott_szuletes_nev_prepend"
                />
              </div>
              <small
                id="biztositott_szuletes_nev-error"
                class="text-danger input-alert"
              ></small>
            </div> -->
          </div>
          <div class="row">
            <ValidationProvider rules="required" v-slot="{errors, classes}" class="col-md-6 mb-3">
              <div class="input-group">
                <div class="input-group-prepend dark-border">
                  <span class="input-group-text" id="ins_birthplace-prepend"
                    ><label for="ins_birthplace">Születési hely:</label>
                    <span class="text-danger">*</span></span
                  >
                </div>
                <input
                  type="text"
                  class="form-control dark-border"
                  id="ins_birthplace"
                  name="ins_birthplace"
                  v-model="insuredBornCity"
                  aria-label="Biztositott Születési hely"
                  :class="classes"
                />
              </div>
              <small id="ins_birthplace-error" class="text-danger input-alert">{{
                errors[0]
              }}</small>
            </ValidationProvider>
            <div class="col-md-6 mb-3">
              <div class="input-group flex-nowrap">
                <div class="input-group-prepend dark-border">
                  <span class="input-group-text" id="ins_birthdate_2-prepend"
                    ><label for="ins_birthdate_2">Születési dátum:</label>
                    <span class="text-danger">*</span></span
                  >
                </div>
                <input
                  id="ins_birthdate_2"
                  autocomplete="off"
                  class="form-control dark-border"
                  type="date"
                  name="ins_birthdate"
                  :min="birthMinDate"
                  :max="birthMaxDate"
                  v-model="insuredBornDate"
                  aria-label="Születési dátum"
                  aria-describedby="ins_birthdate_2-prepend"
                  required
                />
                <!-- <Datepicker
                  id="ins_birthdate_2"
                  name="ins_birthdate_2"
                  :format="'yyyy-MM-dd'"
                  :placeholder="'Kattintson ide a dátum kiválasztásához'"
                  :language="hu"
                  :disabled-dates="bornDisabledDatesIns"
                  :typeable="false"
                  input-class="form-control"
                  :open-date="new Date()"
                  required
                  v-model="insuredBornDate"
                  aria-describedby="ins_birthdate_3-prepend"
                  class="datepicker-prepend-input"
                ></Datepicker> -->
              </div>
              <ValidationProvider
                :immediate="true"
                rules="required|szerzodes_szuletes_datum"
                v-slot="{errors}"
                v-if="!contractedIsInsured"
              >
                <input
                  type="text"
                  name="insuredBornDate"
                  :value="insuredBornDate"
                  disabled
                  hidden
                />
                <small class="text-danger input-alert">{{ errors[0] }}</small>
              </ValidationProvider>
            </div>
          </div>
          <div v-if="!contractedIsInsured">
            <div v-if="nsuMiner" class="form-group row mb-3">
              <label for="ins_email" class="col-sm-4"
                >E-mail cím: <span class="text-danger">*</span></label
              >
              <ValidationProvider
                :rules="{required: electronicContact == 1 ? true : false, email: true}"
                v-slot="{errors, classes}"
                class="col-sm-8"
              >
                <input
                  type="email"
                  class="form-control dark-border"
                  id="ins_email"
                  name="ins_email"
                  v-model="insuredEmail"
                  :class="classes"
                />
                <small id="ins_email-error" class="text-danger input-alert">{{ errors[0] }}</small>
              </ValidationProvider>
            </div>
            <div v-if="nsuMiner" class="form-group row mb-3">
              <label for="ins_email_2" class="col-sm-4"
                >E-mail cím ismételt megadása:
                <span class="text-danger" v-if="insuredEmail != ''">*</span></label
              >
              <ValidationProvider
                :rules="{
                  required_if: 'ins_email',
                  email: true,
                  is: insuredEmailVerification,
                }"
                v-slot="{errors, classes}"
                class="col-sm-8"
              >
                <input
                  type="email"
                  class="form-control dark-border"
                  id="ins_email_2"
                  name="ins_email_2"
                  v-model="insuredEmailVerification"
                  :class="classes"
                  :disabled="emailVerified"
                />
                <small id="ins_email_2-error" class="text-danger input-alert">{{
                  errors[0]
                }}</small>
              </ValidationProvider>
            </div>
          </div>
          <div v-else>
            <div class="text-danger fw-normal mb-3">
              Figyelem! A {{ contractorNameText }} e-mail címének visszaigazolásának céljából egy 6
              számjegyből álló kódot tartalmazó levelet küldünk az Ön által megadott e-mail címre.
              Kérjük, írja be ezt a számsort a következő oldalon erre kijelölt helyen.
              <ul>
                <li>
                  Fontos, hogy akkor is adjon meg e-mail címet, ha a kapcsolattartáshoz a postai
                  kommunikációt választja.
                </li>
                <li>Az e-mail cím megerősítése nélkül a biztosításkötés nem lehetséges.</li>
              </ul>
              A visszaigazoló kód érvényessége: 30 perc.
            </div>
            <div class="form-group row mb-3">
              <label for="ph_email" class="col-sm-4"
                >E-mail cím: <span class="text-danger">*</span></label
              >
              <ValidationProvider
                :rules="{required: electronicContact == 1 ? true : false, email: true}"
                v-slot="{errors, classes}"
                class="col-sm-8"
              >
                <input
                  type="email"
                  class="form-control dark-border"
                  id="ph_email"
                  name="ph_email"
                  v-model="contractorEmail"
                  :class="classes"
                />
                <small id="ins_email-error" class="text-danger input-alert">{{ errors[0] }}</small>
              </ValidationProvider>
            </div>
            <div class="form-group row mb-3">
              <label for="ph_email_2" class="col-sm-4"
                >E-mail cím ismételt megadása:
                <span class="text-danger" v-if="contractorEmail != ''">*</span></label
              >
              <ValidationProvider
                :rules="{required_if: 'ph_email', email: true, is: contractorEmail}"
                v-slot="{errors, classes}"
                class="col-sm-8"
              >
                <input
                  type="email"
                  class="form-control dark-border"
                  id="ph_email_2"
                  name="ph_email_2"
                  v-model="contractorEmailVerification"
                  :class="classes"
                  :disabled="emailVerified"
                />
                <small id="ph_email_2-error" class="text-danger input-alert">{{ errors[0] }}</small>
              </ValidationProvider>
            </div>
            <div class="text-danger mb-3">
              Az e-mail cím megerősítése után az e-mail cím módosítása a későbbiekben már nem
              lehetséges.
            </div>
          </div>
          <div v-if="nsuMiner" class="form-group row">
            <label class="col-sm-4" for="ins_phone"
              >Biztosított telefonszáma: <span class="text-danger">*</span></label
            >
            <ValidationProvider
              rules="required|max:2"
              v-slot="{errors, classes}"
              class="col-sm-3 mb-3"
            >
              <div class="input-group">
                <div class="input-group-prepend dark-border">
                  <label class="input-group-text" id="ins_phone_pre_prepend" for="ins_phone_pre"
                    >+36</label
                  >
                </div>
                <input
                  type="number"
                  min="1"
                  max="99"
                  class="form-control dark-border"
                  id="ins_phone_pre"
                  name="ins_phone_pre"
                  aria-label="Körzetszám"
                  aria-describedby="ins_phone_pre_prepend"
                  v-model.number="insuredPhoneNumberArea"
                  :class="classes"
                />
              </div>
              <small id="ins_phone_pre-error" class="text-danger input-alert">{{
                errors[0]
              }}</small>
            </ValidationProvider>
            <ValidationProvider
              rules="required|min:6|max:7"
              v-slot="{errors, classes}"
              class="col-sm-5"
            >
              <input
                type="number"
                class="form-control dark-border"
                id="ins_phone"
                name="ins_phone"
                v-model="insuredPhoneNumber"
                :class="classes"
              />
              <small id="ins_phone-error" class="text-danger input-alert">{{ errors[0] }}</small>
            </ValidationProvider>
          </div>
        </div>
        <div v-else>
          <div class="row">
            <ValidationProvider rules="required" v-slot="{errors, classes}" class="col-md-6 mb-3">
              <div class="input-group">
                <div class="input-group-prepend dark-border">
                  <label class="input-group-text" id="ins_lastname_prepend" for="ins_lastname"
                    >Vezetéknév: <span class="text-danger">*</span></label
                  >
                </div>
                <input
                  type="text"
                  class="form-control dark-border"
                  id="ins_lastname"
                  name="ins_lastname"
                  v-model="insuredLastName"
                  aria-label="Biztositott Vezetéknév"
                  :class="classes"
                />
              </div>
              <small id="ins_lastname-error" class="text-danger input-alert">{{ errors[0] }}</small>
            </ValidationProvider>
            <ValidationProvider rules="required" v-slot="{errors, classes}" class="col-md-6 mb-3">
              <div class="input-group">
                <div class="input-group-prepend dark-border">
                  <label class="input-group-text" id="ins_firstname_prepend" for="ins_firstname"
                    >Keresztnév: <span class="text-danger">*</span></label
                  >
                </div>
                <input
                  type="text"
                  class="form-control dark-border"
                  id="ins_firstname"
                  name="ins_firstname"
                  v-model="insuredFirstName"
                  aria-label="Biztositott Keresztnév"
                  :class="classes"
                />
              </div>
              <small id="ins_firstname-error" class="text-danger input-alert">{{
                errors[0]
              }}</small>
            </ValidationProvider>
          </div>
          <div class="row">
            <ValidationProvider rules="required" v-slot="{errors, classes}" class="col-md-6 mb-3">
              <div class="input-group">
                <div class="input-group-prepend dark-border">
                  <label class="input-group-text" id="ins_mothersname_prepend" for="ins_mothersname"
                    >Anyja leánykori neve: <span class="text-danger">*</span></label
                  >
                </div>
                <input
                  type="text"
                  class="form-control dark-border"
                  id="ins_mothersname"
                  name="ins_mothersname"
                  v-model="insuredMotherChildName"
                  aria-label="Biztositott anyjanak leánykori neve"
                  :class="classes"
                />
              </div>
              <small id="ins_mothersname-error" class="text-danger input-alert">{{
                errors[0]
              }}</small>
            </ValidationProvider>
          </div>
          <div class="row">
            <ValidationProvider rules="required" v-slot="{errors, classes}" class="col-md-6 mb-3">
              <div class="input-group">
                <div class="input-group-prepend dark-border">
                  <label class="input-group-text" id="ins_birthplace-prepend" for="ins_birthplace"
                    >Születési hely: <span class="text-danger">*</span></label
                  >
                </div>
                <input
                  type="text"
                  class="form-control dark-border"
                  id="ins_birthplace"
                  name="ins_birthplace"
                  v-model="insuredBornCity"
                  aria-label="Biztositott Születési hely"
                  :class="classes"
                />
              </div>
              <small id="ins_birthplace-error" class="text-danger input-alert">{{
                errors[0]
              }}</small>
            </ValidationProvider>
            <div class="col-md-6 mb-3">
              <div class="input-group flex-nowrap">
                <div class="input-group-prepend dark-border">
                  <label
                    class="input-group-text"
                    id="ins_birthdate-prepend_secondpage"
                    for="ins_birthdate_2"
                    >Születési dátum: <span class="text-danger">*</span></label
                  >
                </div>
                <input
                  autocomplete="off"
                  id="ins_birthdate_2"
                  class="form-control dark-border"
                  name="ins_birthdate"
                  type="date"
                  :min="birthMinDateIns"
                  :max="birthMaxDateIns"
                  v-model="insuredBornDate"
                  required
                  aria-label="Születési dátum"
                />
                <!-- <Datepicker
                  id="ins_birthdate"
                  name="ins_birthdate"
                  :format="'yyyy-MM-dd'"
                  :placeholder="'Kattintson ide a dátum kiválasztásához'"
                  :language="hu"
                  :disabled-dates="bornDisabledDatesIns"
                  :typeable="false"
                  input-class="form-control"
                  :open-date="new Date()"
                  required
                  v-model="insuredBornDate"
                  aria-describedby="ins_birthdate-prepend"
                  class="datepicker-prepend-input"
                ></Datepicker> -->
              </div>
              <ValidationProvider
                :immediate="true"
                rules="required|szerzodes_szuletes_datum"
                v-slot="{errors}"
                v-if="!contractedIsInsured"
              >
                <input type="text" name="ins_birthdate" :value="insuredBornDate" disabled hidden />
                <small class="text-danger input-alert">{{ errors[0] }}</small>
              </ValidationProvider>
            </div>
          </div>
          <div v-if="!contractedIsInsured">
            <div v-if="nsuMiner" class="form-group row mb-3">
              <label for="ins_email" class="col-sm-4"
                >E-mail cím: <span class="text-danger">*</span></label
              >
              <ValidationProvider
                :rules="{required: electronicContact == 1 ? true : false, email: true}"
                v-slot="{errors, classes}"
                class="col-sm-8"
              >
                <input
                  type="email"
                  class="form-control dark-border"
                  id="ins_email"
                  name="ins_email"
                  v-model="insuredEmail"
                  :class="classes"
                />
                <small id="ins_email-error" class="text-danger input-alert">{{ errors[0] }}</small>
              </ValidationProvider>
            </div>
            <div v-if="nsuMiner" class="form-group row mb-3">
              <label for="ins_email_2" class="col-sm-4"
                >E-mail cím ismételt megadása:
                <span class="text-danger" v-if="insuredEmail != ''">*</span></label
              >
              <ValidationProvider
                :rules="{
                  required_if: 'ins_email',
                  email: true,
                  is: insuredEmailVerification,
                }"
                v-slot="{errors, classes}"
                class="col-sm-8"
              >
                <input
                  type="email"
                  class="form-control dark-border"
                  id="ins_email_2"
                  name="ins_email_2"
                  v-model="insuredEmailVerification"
                  :class="classes"
                  :disabled="emailVerified"
                />
                <small id="ins_email_2-error" class="text-danger input-alert">{{
                  errors[0]
                }}</small>
              </ValidationProvider>
            </div>
          </div>
          <div v-else>
            <div class="text-danger fw-normal mb-3">
              Figyelem! A {{ contractorNameText }} e-mail címének visszaigazolásának céljából egy 6
              számjegyből álló kódot tartalmazó levelet küldünk az Ön által megadott e-mail címre.
              Kérjük, írja be ezt a számsort a következő oldalon erre kijelölt helyen.
              <ul>
                <li>
                  Fontos, hogy akkor is adjon meg e-mail címet, ha a kapcsolattartáshoz a postai
                  kommunikációt választja.
                </li>
                <li>Az e-mail cím megerősítése nélkül a biztosításkötés nem lehetséges.</li>
              </ul>
              A visszaigazoló kód érvényessége: 30 perc.
            </div>
            <div class="form-group row mb-3">
              <label for="ph_email" class="col-sm-4"
                >E-mail cím: <span class="text-danger">*</span></label
              >
              <ValidationProvider
                :rules="{required: electronicContact == 1 ? true : false, email: true}"
                v-slot="{errors, classes}"
                class="col-sm-8"
              >
                <input
                  type="email"
                  class="form-control dark-border"
                  id="ph_email"
                  name="ph_email"
                  v-model="contractorEmail"
                  :class="classes"
                />
                <small id="ins_email-error" class="text-danger input-alert">{{ errors[0] }}</small>
              </ValidationProvider>
            </div>
            <div class="form-group row mb-3">
              <label for="ph_email_2" class="col-sm-4"
                >E-mail cím ismételt megadása:
                <span class="text-danger" v-if="contractorEmail != ''">*</span></label
              >
              <ValidationProvider
                :rules="{required_if: 'ph_email', email: true, is: contractorEmail}"
                v-slot="{errors, classes}"
                class="col-sm-8"
              >
                <input
                  type="email"
                  class="form-control dark-border"
                  id="ph_email_2"
                  name="ph_email_2"
                  v-model="contractorEmailVerification"
                  :class="classes"
                  :disabled="emailVerified"
                />
                <small id="ph_email_2-error" class="text-danger input-alert">{{ errors[0] }}</small>
              </ValidationProvider>
            </div>
            <div class="text-danger mb-3">
              Az e-mail cím megerősítése után az e-mail cím módosítása a későbbiekben már nem
              lehetséges.
            </div>
          </div>
          <div v-if="nsuMiner" class="form-group row">
            <label class="col-sm-4" for="ins_phone"
              >Biztosított telefonszáma: <span class="text-danger">*</span></label
            >
            <ValidationProvider
              rules="required|max:2"
              v-slot="{errors, classes}"
              class="col-sm-3 mb-3"
            >
              <div class="input-group">
                <div class="input-group-prepend dark-border">
                  <span class="input-group-text" id="ins_phone_pre_prepend"
                    ><label for="ins_phone_pre">+36</label></span
                  >
                </div>
                <input
                  type="number"
                  min="1"
                  max="99"
                  class="form-control dark-border"
                  id="ins_phone_pre"
                  name="ins_phone_pre"
                  aria-label="Körzetszám"
                  aria-describedby="ins_phone_pre_prepend"
                  v-model.number="insuredPhoneNumberArea"
                  :class="classes"
                />
              </div>
              <small id="ins_phone_pre-error" class="text-danger input-alert">{{
                errors[0]
              }}</small>
            </ValidationProvider>
            <ValidationProvider
              rules="required|min:6|max:7"
              v-slot="{errors, classes}"
              class="col-sm-5"
            >
              <input
                type="number"
                class="form-control dark-border"
                id="ins_phone"
                name="ins_phone"
                v-model="insuredPhoneNumber"
                :class="classes"
              />
              <small id="ins_phone-error" class="text-danger input-alert">{{ errors[0] }}</small>
            </ValidationProvider>
          </div>
        </div>
      </div>
      <div>
        <div v-if="nsuMiner">
          <h1 class="h2 mt-4">A biztosított lakcíme</h1>
          <div class="row">
            <ValidationProvider rules="required|zipcode" v-slot="{errors}" class="col-md-6 mb-3">
              <div class="input-group">
                <div class="input-group-prepend dark-border">
                  <label class="input-group-text" id="ins_zip-prepend" for="ins_zip"
                    >Irányítószám: <span class="text-danger">*</span></label
                  >
                </div>
                <div class="flex-grow-1">
                  <!-- <Select2
                    id="ins_zip"
                    name="ins_zip"
                    v-model="locationZip"
                    :options="zipCodes"
                    :settings="{selectionCssClass: 'w-full'}"
                  /> -->
                  <input
                    type="text"
                    id="ins_zip"
                    name="ins_zip"
                    v-model="locationZip"
                    class="form-control dark-border"
                  />
                </div>
              </div>
              <small id="ins_zip-error" class="text-danger input-alert">{{ errors[0] }}</small>
            </ValidationProvider>
            <div class="col-md-6 mb-3">
              <div class="input-group">
                <div class="input-group-prepend dark-border">
                  <label class="input-group-text" id="ins_city-prepend" for="ins_city"
                    >Település neve: <span class="text-danger">*</span></label
                  >
                </div>
                <div class="flex-grow-1" v-if="cityNames.length > 1">
                  <select
                    id="ins_city"
                    name="ins_city"
                    v-model="locationCity"
                    class="form-select dark-border"
                  >
                    <option v-for="(city, key) in cityNames" :key="key" :value="city">{{
                      city
                    }}</option>
                  </select>
                  <!-- <Select2
                    name="ins_city"
                    v-model="locationCity"
                    :options="cityNames"
                    :settings="{selectionCssClass: 'w-full'}"
                  /> -->
                </div>
                <input
                  v-else
                  id="ins_city"
                  type="text"
                  class="form-control dark-border"
                  readonly
                  name="ins_city"
                  :value="locationCity"
                />
              </div>
              <ValidationProvider rules="required" v-slot="{errors}" class="col-md-6 mb-3">
                <input v-show="false" :value="locationCity" />
                <small id="ins_city-error" class="text-danger input-alert">{{ errors[0] }}</small>
              </ValidationProvider>
            </div>
          </div>
          <div class="row">
            <ValidationProvider rules="required" v-slot="{errors, classes}" class="col-md-6 mb-3">
              <div class="input-group">
                <div class="input-group-prepend dark-border">
                  <label
                    class="input-group-text"
                    id="ins_add_streetname-prepend"
                    for="ins_add_streetname"
                    >Közterület neve: <span class="text-danger">*</span></label
                  >
                </div>
                <input
                  type="text"
                  class="form-control dark-border"
                  id="ins_add_streetname"
                  name="ins_add_streetname"
                  v-model="locationName"
                  aria-label="Közterület neve"
                  aria-describedby="ins_add_streetname-prepend"
                  :class="classes"
                />
              </div>
              <small id="ins_add_streetname-error" class="text-danger input-alert">{{
                errors[0]
              }}</small>
            </ValidationProvider>
            <ValidationProvider rules="required" v-slot="{errors, classes}" class="col-md-6 mb-3">
              <div class="input-group">
                <div class="input-group-prepend dark-border">
                  <label
                    class="input-group-text"
                    id="ins_add_streettype-prepend"
                    for="ins_add_streettype"
                    >Közterület jellege: <span class="text-danger">*</span></label
                  >
                </div>
                <input
                  type="text"
                  class="form-control dark-border"
                  id="ins_add_streettype"
                  name="ins_add_streettype"
                  v-model="locationType"
                  aria-label="Közterület jellege"
                  aria-describedby="ins_add_streettype-prepend"
                  :class="classes"
                />
              </div>
              <small id="ins_add_streettype-error" class="text-danger input-alert">{{
                errors[0]
              }}</small>
            </ValidationProvider>
          </div>
          <div class="row">
            <ValidationProvider rules="required" v-slot="{errors, classes}" class="col-md-6 mb-3">
              <div class="input-group">
                <div class="input-group-prepend dark-border">
                  <label
                    class="input-group-text"
                    id="ins_add_streetno-prepend"
                    for="ins_add_streetno"
                    >Házszám: <span class="text-danger">*</span></label
                  >
                </div>
                <input
                  type="text"
                  class="form-control dark-border"
                  id="ins_add_streetno"
                  name="ins_add_streetno"
                  v-model="locationHouseNumber"
                  aria-label="Házszám"
                  aria-describedby="ins_add_streetno-prepend"
                  :class="classes"
                />
              </div>
              <small id="ins_add_streetno-error" class="text-danger input-alert">{{
                errors[0]
              }}</small>
            </ValidationProvider>
            <div class="col-md-6 mb-3">
              <div class="input-group">
                <div class="input-group-prepend dark-border">
                  <label class="input-group-text" id="ins_add_other-prepend" for="ins_add_other"
                    >Épület, emelet, ajtó:</label
                  >
                </div>
                <input
                  type="text"
                  class="form-control dark-border"
                  id="ins_add_other"
                  name="ins_add_other"
                  v-model="locationBuilding"
                  aria-label="Épület, emelet, ajtó"
                  aria-describedby="ins_add_other-prepend"
                />
              </div>
              <small id="ins_add_other-error" class="text-danger input-alert"></small>
            </div>
          </div>
        </div>
        <!-- <div class="form-group row mb-3">
          <label class="col-sm-4" for="kockazat_helyrajzi_szam"
            >Helyrajzi szám:
            <span
              class="info border border-white"
              id="kockazat_helyrajzi_szam-tooltip"
              data-toggle="tooltip"
              data-placement="right"
              title=""
              >?</span
            ></label
          >
          <div class="col-sm-8">
            <input
              class="form-control"
              type="text"
              id="kockazat_helyrajzi_szam"
              name="kockazat_helyrajzi_szam"
              v-model="locationTopography"
            />
          </div>
        </div> -->
        <div class="form-group row mb-3">
          <div v-show="!nsuMiner">
            <h1 class="h2 mt-4">
              {{ contractorNameText }} adatai
              <button
                class="info border border-white"
                id="uzenet_csatlakozasi-tooltip"
                data-toggle="tooltip"
                data-placement="right"
                title=""
                type="button"
              >
                ?
              </button>
            </h1>
          </div>
          <div v-show="false">
            <label class="col-sm-4"
              >A {{ contractorNameText }} személye megegyezik a biztosított személlyel?</label
            >
            <div class="col-sm-8">
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="radio"
                  name="ph_is_ins"
                  id="szerzodo_biztositott_igen"
                  :value="1"
                  v-model="contractedIsInsured"
                  :disabled="getAge(insuredBornDate) <= 18"
                />
                <label class="form-check-label" for="szerzodo_biztositott_igen">
                  Igen
                </label>
              </div>
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="radio"
                  name="ph_is_ins"
                  id="szerzodo_biztositott_nem"
                  :value="0"
                  v-model="contractedIsInsured"
                  :disabled="getAge(insuredBornDate) > 18"
                />
                <label class="form-check-label" for="szerzodo_biztositott_nem">
                  Nem
                </label>
              </div>
            </div>
          </div>
        </div>
        <div v-show="!contractedIsInsured && merchant_id !== 'nsu'" class="form-group row mb-3">
          <label class="col-sm-4"
            >A {{ contractorNameText }} magánszemély?
            <button
              type="button"
              class="info border border-white"
              id="person-tooltip"
              data-toggle="tooltip"
              data-placement="right"
              title=""
            >
              ?
            </button></label
          >
          <div class="col-sm-8">
            <div class="form-check">
              <input
                type="radio"
                class="form-check-input"
                id="person-1"
                name="person"
                :value="1"
                v-model="privatePerson"
              />
              <label for="person" class="form-check-label">Igen</label>
            </div>
            <div class="form-check">
              <input
                type="radio"
                class="form-check-input"
                id="person-2"
                name="person"
                :value="0"
                v-model="privatePerson"
              />
              <label for="person" class="form-check-label">Nem</label>
            </div>
          </div>
        </div>

        <div v-if="!privatePerson && !contractedIsInsured">
          <div class="row">
            <ValidationProvider rules="required" v-slot="{errors, classes}" class="col-md-6 mb-3">
              <div class="input-group">
                <div class="input-group-prepend dark-border">
                  <span class="input-group-text" id="ph_companyname-prepend"
                    ><label for="ph_companyname">Név: </label
                    ><span class="text-danger">*</span></span
                  >
                </div>
                <input
                  type="text"
                  class="form-control dark-border"
                  id="ph_companyname"
                  name="ph_companyname"
                  v-model="contractorCompanyName"
                  aria-label="Vezetéknév"
                  aria-describedby="ph_companyname-prepend"
                  :class="classes"
                />
              </div>
              <small id="ph_companyname-error" class="text-danger input-alert">{{
                errors[0]
              }}</small>
            </ValidationProvider>
            <ValidationProvider rules="required" v-slot="{errors, classes}" class="col-md-6 mb-3">
              <div class="input-group">
                <div class="input-group-prepend dark-border">
                  <span class="input-group-text" id="ph_tax-prepend"
                    ><label for="ph_tax">Adószám:</label> <span class="text-danger">*</span></span
                  >
                </div>
                <input
                  type="text"
                  class="form-control dark-border"
                  id="ph_tax"
                  name="ph_tax"
                  v-model="contractorVat"
                  aria-label="Adószám"
                  aria-describedby="ph_tax-prepend"
                  :class="classes"
                />
              </div>
              <small id="ph_tax-error" class="text-danger input-alert">{{ errors[0] }}</small>
            </ValidationProvider>
          </div>
          <div class="text-danger fw-normal mb-3">
            Figyelem! A {{ contractorNameText }} e-mail címének visszaigazolásának céljából egy 6
            számjegyből álló kódot tartalmazó levelet küldünk az Ön által megadott e-mail címre.
            Kérjük, írja be ezt a számsort a következő oldalon erre kijelölt helyen.
            <ul>
              <li>
                Fontos, hogy akkor is adjon meg e-mail címet, ha a kapcsolattartáshoz a postai
                kommunikációt választja.
              </li>
              <li>Az e-mail cím megerősítése nélkül a biztosításkötés nem lehetséges.</li>
            </ul>
            A visszaigazoló kód érvényessége: 30 perc.
          </div>
          <div class="form-group row mb-3">
            <label for="ph_email" class="col-sm-4">
              {{ contractorNameText }} e-mail címe: <span class="text-danger">*</span>
            </label>
            <ValidationProvider
              :rules="{required: electronicContact == 1 ? true : false, email: true}"
              vid="ph_email"
              v-slot="{errors, classes}"
              class="col-sm-8 dark-border"
            >
              <input
                type="email"
                class="form-control dark-border"
                id="ph_email"
                name="ph_email"
                v-model="contractorEmail"
                :class="classes"
                :disabled="emailVerified"
              />
              <small id="ph_email-error" class="text-danger input-alert">{{ errors[0] }}</small>
            </ValidationProvider>
          </div>
          <div class="form-group row mb-3">
            <label for="ph_email_2" class="col-sm-4"
              >{{ contractorNameText }} e-mail címének ismételt megadása:
              <span class="text-danger" v-if="contractorEmail != ''">*</span></label
            >
            <ValidationProvider
              :rules="{required_if: 'ph_email', email: true, is: contractorEmail}"
              v-slot="{errors, classes}"
              class="col-sm-8 dark-border"
            >
              <input
                type="email"
                class="form-control dark-border"
                id="ph_email_2"
                name="ph_email_2"
                v-model="contractorEmailVerification"
                :class="classes"
                :disabled="emailVerified"
              />
              <small id="ph_email_2-error" class="text-danger input-alert">{{ errors[0] }}</small>
            </ValidationProvider>
          </div>
          <div class="text-danger mb-3">
            Az e-mail cím megerősítése után az e-mail cím módosítása a későbbiekben már nem
            lehetséges.
          </div>
          <div class="form-group row">
            <label class="col-sm-4" for="ph_phone"
              >{{ contractorNameText }} telefonszáma: <span class="text-danger">*</span></label
            >
            <ValidationProvider
              rules="required|max:2"
              v-slot="{errors, classes}"
              class="col-sm-3 mb-3"
            >
              <div class="input-group">
                <div class="input-group-prepend dark-border">
                  <span class="input-group-text" id="ph_phone_area_prepend">+36</span>
                </div>
                <input
                  type="number"
                  min="1"
                  max="99"
                  class="form-control"
                  id="ph_phone_area"
                  name="ph_phone_area"
                  aria-label="Körzetszám"
                  aria-describedby="ph_phone_area_prepend"
                  v-model.number="contractorPhoneNumberArea"
                  :class="classes"
                />
              </div>
              <small id="ph_phone_area-error" class="text-danger input-alert">{{
                errors[0]
              }}</small>
            </ValidationProvider>
            <ValidationProvider
              rules="required|min:6|max:7"
              v-slot="{errors, classes}"
              class="col-sm-5"
            >
              <input
                type="number"
                class="form-control dark-border"
                id="ph_phone"
                name="ph_phone"
                v-model="contractorPhoneNumber"
                :class="classes"
              />
              <small id="ph_phone-error" class="text-danger input-alert">{{ errors[0] }}</small>
            </ValidationProvider>
          </div>
          <h2 class="mt-4">Székhely</h2>
          <div class="row">
            <ValidationProvider rules="required|zipcode" v-slot="{errors}" class="col-md-6 mb-3">
              <div class="input-group">
                <div class="input-group-prepend dark-border">
                  <span class="input-group-text" id="ph_zip-prepend"
                    ><label for="ph_zip">Irányítószám:</label>
                    <span class="text-danger">*</span></span
                  >
                </div>
                <div class="flex-grow-1">
                  <input
                    type="text"
                    id="ph_zip"
                    name="ph_zip"
                    v-model="companyLocationZip"
                    class="form-control dark-border"
                  />
                  <!-- <Select2
                    id="ph_zip"
                    name="ph_zip"
                    v-model="companyLocationZip"
                    :options="zipCodes"
                    :settings="{ selectionCssClass: 'w-full' }"
                  /> -->
                </div>
              </div>
              <small id="ph_zip-error" class="text-danger input-alert">{{ errors[0] }}</small>
            </ValidationProvider>

            <div class="col-md-6 mb-3">
              <div class="input-group">
                <div class="input-group-prepend dark-border">
                  <span class="input-group-text" id="ph_city-prepend"
                    ><label for="ph_city">Település neve:</label>
                    <span class="text-danger">*</span></span
                  >
                </div>
                <div class="flex-grow-1" v-if="companyCityNames.length > 1">
                  <select
                    id="ph_city"
                    name="ph_city"
                    v-model="companyLocationCity"
                    class="form-select dark-border"
                  >
                    <option v-for="(city, key) in companyCityNames" :key="key" :value="city">{{
                      city
                    }}</option>
                  </select>
                  <!-- <Select2
                    id="ph_city"
                    name="ph_city"
                    v-model="companyLocationCity"
                    :options="companyCityNames"
                    :settings="{ selectionCssClass: 'w-full' }"
                  /> -->
                </div>
                <input
                  v-else
                  id="ph_city"
                  type="text"
                  class="form-control dark-border"
                  readonly
                  name="ph_city"
                  :value="companyLocationCity"
                />
              </div>
              <ValidationProvider rules="required" v-slot="{errors}" class="col-md-6 mb-3">
                <input v-show="false" :value="companyLocationCity" />
                <small id="ph_city-error" class="text-danger input-alert">{{ errors[0] }}</small>
              </ValidationProvider>
            </div>
          </div>
          <div class="row">
            <ValidationProvider rules="required" v-slot="{errors, classes}" class="col-md-6 mb-3">
              <div class="input-group">
                <div class="input-group-prepend dark-border">
                  <span class="input-group-text" id="ph_add_streetname-prepend"
                    ><label for="companyLocationName">Közterület neve:</label>
                    <span class="text-danger">*</span></span
                  >
                </div>
                <input
                  type="text"
                  class="form-control dark-border"
                  id="companyLocationName"
                  name="companyLocationName"
                  v-model="companyLocationName"
                  aria-label="Közterület neve"
                  aria-describedby="ph_add_streetname-prepend"
                  :class="classes"
                />
              </div>
              <small id="ph_add_streetname-error" class="text-danger input-alert">{{
                errors[0]
              }}</small>
            </ValidationProvider>
            <ValidationProvider rules="required" v-slot="{errors, classes}" class="col-md-6 mb-3">
              <div class="input-group">
                <div class="input-group-prepend dark-border">
                  <span class="input-group-text" id="ph_public_space-prepend"
                    ><label for="ph_add_streettype">Közterület jellege:</label>
                    <span class="text-danger">*</span></span
                  >
                </div>
                <input
                  type="text"
                  class="form-control dark-border"
                  id="ph_add_streettype"
                  name="ph_add_streettype"
                  v-model="companyLocationType"
                  aria-label="Közterület jellege"
                  :class="classes"
                />
              </div>
              <small id="ph_add_streettype-error" class="text-danger input-alert">{{
                errors[0]
              }}</small>
            </ValidationProvider>
          </div>
          <div class="row">
            <ValidationProvider rules="required" v-slot="{errors, classes}" class="col-md-6 mb-3">
              <div class="input-group">
                <div class="input-group-prepend dark-border">
                  <span class="input-group-text" id="ph_add_streetno-prepend"
                    ><label for="ph_add_streetno">Házszám:</label>
                    <span class="text-danger">*</span></span
                  >
                </div>
                <input
                  type="text"
                  class="form-control dark-border"
                  id="ph_add_streetno"
                  name="ph_add_streetno"
                  v-model="companyLocationHouseNumber"
                  aria-label="Házszám"
                  aria-describedby="ph_add_streetno-prepend"
                  :class="classes"
                />
              </div>
              <small id="ph_add_streetno-error" class="text-danger input-alert">{{
                errors[0]
              }}</small>
            </ValidationProvider>
            <div class="col-md-6 mb-3">
              <div class="input-group">
                <div class="input-group-prepend dark-border">
                  <span class="input-group-text" id="ph_add_other-prepend"
                    ><label for="ph_floar">Épület, emelet, ajtó:</label></span
                  >
                </div>
                <input
                  type="text"
                  class="form-control dark-border"
                  id="ph_add_other"
                  name="ph_add_other"
                  v-model="companyLocationBuilding"
                  aria-label="Épület, emelet, ajtó"
                  aria-describedby="ph_floar-prepend"
                />
              </div>
              <small id="ph_add_other-error" class="text-danger input-alert"></small>
            </div>
          </div>
        </div>
      </div>
      <div v-if="!contractedIsInsured && privatePerson && !nsuMiner">
        <div class="row">
          <ValidationProvider rules="required" v-slot="{errors, classes}" class="col-md-6 mb-3">
            <div class="input-group">
              <div class="input-group-prepend dark-border">
                <span class="input-group-text" id="ph_lastname-prepend"
                  ><label for="ph_lastname">Vezetéknév:</label>
                  <span class="text-danger">*</span></span
                >
              </div>
              <input
                type="text"
                class="form-control dark-border"
                id="ph_lastname"
                name="ph_lastname"
                v-model="contractorLastName"
                aria-label="Vezetéknév"
                :class="classes"
                v-if="privatePerson && !contractedIsInsured"
              />
              <input
                type="text"
                class="form-control dark-border"
                id="ph_lastname"
                name="ph_lastname"
                v-model="insuredLastName"
                aria-label="Vezetéknév"
                aria-describedby="ph_lastname-prepend"
                :class="classes"
                v-else
              />
            </div>
            <small id="ph_lastname-error" class="text-danger input-alert">{{ errors[0] }}</small>
          </ValidationProvider>
          <ValidationProvider rules="required" v-slot="{errors, classes}" class="col-md-6 mb-3">
            <div class="input-group">
              <div class="input-group-prepend dark-border">
                <span class="input-group-text" id="ph_firstname-prepend"
                  ><label for="ph_firstname">Keresztnév:</label>
                  <span class="text-danger">*</span></span
                >
              </div>
              <input
                type="text"
                class="form-control dark-border"
                id="ph_firstname"
                name="ph_firstname"
                v-model="contractorFirstName"
                aria-label="Keresztnév"
                :class="classes"
                v-if="privatePerson && !contractedIsInsured"
              />
              <input
                type="text"
                class="form-control dark-border"
                id="ph_firstname"
                name="ph_firstname"
                v-model="insuredFirstName"
                aria-label="Keresztnév"
                aria-describedby="ph_firstname-prepend"
                :class="classes"
                v-else
              />
            </div>
            <small id="ph_firstname-error" class="text-danger input-alert">{{ errors[0] }}</small>
          </ValidationProvider>
        </div>
        <div class="row">
          <ValidationProvider rules="required" v-slot="{errors, classes}" class="col-md-6 mb-3">
            <div class="input-group">
              <div class="input-group-prepend dark-border">
                <span class="input-group-text" id="ph_mothersname-prepend"
                  ><label for="ph_mothersname">Anyja leánykori neve:</label>
                  <span class="text-danger">*</span></span
                >
              </div>
              <input
                type="text"
                class="form-control dark-border"
                id="ph_mothersname"
                name="ph_mothersname"
                v-model="contractorMotherChildName"
                aria-label="Anyja leánykori neve"
                :class="classes"
                v-if="privatePerson && !contractedIsInsured"
              />
              <input
                type="text"
                class="form-control dark-border"
                id="ph_mothersname"
                name="ph_mothersname"
                v-model="insuredMotherChildName"
                aria-label="Anyja leánykori neve"
                aria-describedby="ph_mothersname-prepend"
                :class="classes"
                v-else
              />
            </div>
            <small id="ph_mothersname-error" class="text-danger input-alert">{{ errors[0] }}</small>
          </ValidationProvider>
          <!-- <div class="col-md-6 mb-3">
            <div class="input-group">
              <div class="input-group-prepend">
                <span class="input-group-text" id="szerzodo_szuletes_nev-prepend"
                  ><label for="szerzodo_szuletes_nev">Születéskori neve:</label></span
                >
              </div>
              <input
                type="text"
                class="form-control dark-border"
                id="szerzodo_szuletes_nev"
                name="szerzodo_szuletes_nev"
                v-model="contractorBornName"
                aria-label="Születéskori neve"
                aria-describedby="szerzodo_szuletes_nev-prepend"
                v-if="privatePerson && !contractedIsInsured"
              />
              <input
                type="text"
                class="form-control dark-border"
                id="szerzodo_szuletes_nev"
                name="szerzodo_szuletes_nev"
                v-model="insuredBornName"
                aria-label="Születéskori neve"
                aria-describedby="szerzodo_szuletes_nev-prepend"
                v-else
              />
            </div>
            <small
              id="szerzodo_szuletes_nev-error"
              class="text-danger input-alert"
            ></small>
          </div> -->
        </div>
        <div class="row">
          <ValidationProvider rules="required" v-slot="{errors, classes}" class="col-md-6 mb-3">
            <div class="input-group">
              <div class="input-group-prepend dark-border">
                <span class="input-group-text" id="ph_birthplace-prepend"
                  ><label for="ph_birthplace">Születési hely:</label>
                  <span class="text-danger">*</span></span
                >
              </div>
              <input
                type="text"
                class="form-control dark-border"
                id="ph_birthplace"
                name="ph_birthplace"
                v-model="contractorBornCity"
                aria-label="Születési hely"
                :class="classes"
                v-if="privatePerson && !contractedIsInsured"
              />
              <input
                type="text"
                class="form-control dark-border"
                id="ph_birthplace"
                name="ph_birthplace"
                v-model="insuredBornCity"
                aria-label="Születési hely"
                :class="classes"
                v-else
              />
            </div>
            <small id="ph_birthplace-error" class="text-danger input-alert">{{ errors[0] }}</small>
          </ValidationProvider>
          <div class="col-md-6 mb-3">
            <div class="input-group flex-nowrap">
              <div class="input-group-prepend dark-border">
                <span class="input-group-text" id="ph_birthdate-prepend"
                  ><label for="ph_birthdate">Születési dátum:</label>
                  <span class="text-danger">*</span></span
                >
              </div>
              <input
                id="ph_birthdate"
                autocomplete="off"
                class="form-control dark-border"
                type="date"
                name="ph_birthdate"
                :min="contractedIsInsured ? biztMinDate : birthMinDate"
                :max="contractedIsInsured ? biztMaxDate : birthMaxDate"
                v-model="contractorBornDate"
                required
                v-if="privatePerson && !contractedIsInsured"
              />
              <input
                id="ph_birthdate"
                autocomplete="off"
                class="form-control dark-border"
                type="date"
                name="ph_birthdate"
                :min="contractedIsInsured ? biztMinDate : birthMinDate"
                :max="contractedIsInsured ? biztMaxDate : birthMaxDate"
                v-model="insuredBornDate"
                required
                readonly
                v-else
              />
              <!-- <Datepicker
                id="ph_birthdate"
                name="ph_birthdate"
                :format="'yyyy-MM-dd'"
                :placeholder="'Kattintson ide a dátum kiválasztásához'"
                :language="hu"
                :disabled-dates="
                  contractedIsInsured ? biztDisabledDates : bornDisabledDates
                "
                :typeable="false"
                input-class="form-control"
                :open-date="bornInitialDate"
                required
                v-model="contractorBornDate"
                aria-describedby="ph_birthdate-prepend"
                class="datepicker-prepend-input"
                readonly
                v-if="privatePerson && !contractedIsInsured"
              ></Datepicker> -->
              <!-- <Datepicker
                id="ph_birthdate"
                name="ph_birthdate"
                :format="'yyyy-MM-dd'"
                :placeholder="'Kattintson ide a dátum kiválasztásához'"
                :language="hu"
                :disabled-dates="
                  contractedIsInsured ? biztDisabledDates : bornDisabledDates
                "
                :typeable="false"
                input-class="form-control"
                :open-date="bornInitialDate"
                required
                v-model="insuredBornDate"
                aria-describedby="ph_birthdate-prepend"
                class="datepicker-prepend-input"
                readonly
                v-else
              ></Datepicker> -->
            </div>
            <ValidationProvider
              :immediate="true"
              rules="required|szerzodes_szuletes_datum"
              v-slot="{errors}"
            >
              <input
                class="dark-border"
                type="text"
                name="ph_birthdate"
                :value="contractorBornDate"
                disabled
                hidden
              />
              <small class="text-danger input-alert">{{ errors[0] }}</small>
            </ValidationProvider>
          </div>
        </div>
        <div class="text-danger fw-normal mb-3"></div>
        <div class="text-danger fw-normal mb-3">
          Figyelem! A {{ contractorNameText }} e-mail címének visszaigazolásának céljából egy 6
          számjegyből álló kódot tartalmazó levelet küldünk az Ön által megadott e-mail címre.
          Kérjük, írja be ezt a számsort a következő oldalon erre kijelölt helyen.
          <ul>
            <li>
              Fontos, hogy akkor is adjon meg e-mail címet, ha a kapcsolattartáshoz a postai
              kommunikációt választja.
            </li>
            <li>Az e-mail cím megerősítése nélkül a biztosításkötés nem lehetséges.</li>
          </ul>
          A visszaigazoló kód érvényessége: 30 perc.
        </div>
        <div class="form-group row mb-3">
          <label for="ph_email" class="col-sm-4">
            {{ contractorNameText }} <label for="ph_email">e-mail címe:</label>
            <span class="text-danger">*</span>
          </label>
          <ValidationProvider
            :rules="{required: electronicContact == 1 ? true : false, email: true}"
            vid="ph_email"
            v-slot="{errors, classes}"
            class="col-sm-8 dark-border"
          >
            <input
              type="email"
              class="form-control dark-border"
              id="ph_email"
              name="ph_email"
              v-model="insuredEmail"
              :class="classes"
              :disabled="emailVerified"
              v-if="!privatePerson && !contractedIsInsured"
            />
            <input
              type="email"
              class="form-control dark-border"
              id="ph_email"
              name="ph_email"
              v-model="contractorEmail"
              :class="classes"
              :disabled="emailVerified"
              v-else
            />
            <small id="ph_email-error" class="text-danger input-alert">{{ errors[0] }}</small>
          </ValidationProvider>
        </div>
        <div class="form-group row mb-3">
          <label for="ph_email_2" class="col-sm-4"
            >{{ contractorNameText }} e-mail címének ismételt megadása:
            <span class="text-danger" v-if="contractorEmail != ''">*</span></label
          >
          <ValidationProvider
            :rules="{required_if: 'szerzodo_email', email: true, is: contractorEmail}"
            v-slot="{errors, classes}"
            class="col-sm-8"
          >
            <input
              type="email"
              class="form-control dark-border"
              id="ph_email_2"
              name="ph_email_2"
              v-model="contractorEmailVerification"
              :class="classes"
              :disabled="emailVerified"
            />
            <small id="ph_email_2-error" class="text-danger input-alert">{{ errors[0] }}</small>
          </ValidationProvider>
        </div>
        <div class="text-danger mb-3">
          Az e-mail cím megerősítése után az e-mail cím módosítása a későbbiekben már nem
          lehetséges.
        </div>
        <div class="form-group row">
          <label class="col-sm-4" for="ph_phone"
            >{{ contractorNameText }} telefonszáma: <span class="text-danger">*</span></label
          >
          <ValidationProvider
            rules="required|max:2"
            v-slot="{errors, classes}"
            class="col-sm-3 mb-3"
          >
            <div class="input-group">
              <div class="input-group-prepend dark-border">
                <span class="input-group-text" id="ph_phone_pre_prepend">+36</span>
              </div>
              <input
                type="number"
                min="1"
                max="99"
                class="form-control dark-border"
                id="ph_phone_pre"
                name="ph_phone_pre"
                aria-label="Körzetszám"
                aria-describedby="ph_phone_pre_prepend"
                v-model.number="contractorPhoneNumberArea"
                :class="classes"
              />
            </div>
            <small id="ph_phone_pre-error" class="text-danger input-alert">{{ errors[0] }}</small>
          </ValidationProvider>
          <ValidationProvider
            rules="required|min:6|max:7"
            v-slot="{errors, classes}"
            class="col-sm-5"
          >
            <input
              type="number"
              class="form-control dark-border"
              id="ph_phone"
              name="ph_phone"
              v-model="contractorPhoneNumber"
              :class="classes"
            />
            <small id="ph_phone-error" class="text-danger input-alert">{{ errors[0] }}</small>
          </ValidationProvider>
        </div>
        <h2 class="mt-4">{{ contractorNameText }} lakcíme</h2>
        <div class="row">
          <ValidationProvider rules="required|zipcode" v-slot="{errors}" class="col-md-6 mb-3">
            <div class="input-group">
              <div class="input-group-prepend dark-border">
                <span class="input-group-text" id="ph_zip-prepend"
                  ><label for="ph_zip">Irányítószám:</label>
                  <span class="text-danger">*</span></span
                >
              </div>
              <div class="flex-grow-1">
                <input
                  type="text"
                  id="ph_zip"
                  name="ph_zip"
                  v-model="companyLocationZip"
                  class="form-control dark-border"
                />
                <!-- <Select2
                  id="ph_zip"
                  name="ph_zip"
                  v-model="companyLocationZip"
                  :options="zipCodes"
                  :settings="{ selectionCssClass: 'w-full' }"
                /> -->
              </div>
            </div>
            <small id="ph_zip-error" class="text-danger input-alert">{{ errors[0] }}</small>
          </ValidationProvider>

          <div class="col-md-6 mb-3">
            <div class="input-group">
              <div class="input-group-prepend dark-border">
                <span class="input-group-text" id="ph_city-prepend"
                  ><label for="ph_city">Település neve:</label>
                  <span class="text-danger">*</span></span
                >
              </div>
              <div class="flex-grow-1" v-if="companyCityNames.length > 1">
                <select
                  id="ph_city"
                  name="ph_city"
                  v-model="companyLocationCity"
                  class="form-select dark-border"
                >
                  <option v-for="(city, key) in companyCityNames" :key="key" :value="city">{{
                    city
                  }}</option>
                </select>
                <!-- <Select2
                  id="ph_city"
                  name="ph_city"
                  v-model="companyLocationCity"
                  :options="companyCityNames"
                  :settings="{ selectionCssClass: 'w-full' }"
                /> -->
              </div>
              <input
                v-else
                id="ph_city"
                type="text"
                class="form-control dark-border"
                readonly
                name="ph_city"
                :value="companyLocationCity"
              />
            </div>
            <ValidationProvider rules="required" v-slot="{errors}" class="col-md-6 mb-3">
              <input v-show="false" :value="companyLocationCity" />
              <small id="ph_city-error" class="text-danger input-alert">{{ errors[0] }}</small>
            </ValidationProvider>
          </div>
        </div>
        <div class="row">
          <ValidationProvider rules="required" v-slot="{errors, classes}" class="col-md-6 mb-3">
            <div class="input-group">
              <div class="input-group-prepend dark-border">
                <span class="input-group-text" id="ph_add_streetname-prepend"
                  ><label for="companyLocationName">Közterület neve:</label>
                  <span class="text-danger">*</span></span
                >
              </div>
              <input
                type="text"
                class="form-control dark-border"
                id="companyLocationName"
                name="ph_add_streetname"
                v-model="companyLocationName"
                aria-label="Közterület neve"
                aria-describedby="ph_add_streetname-prepend"
                :class="classes"
              />
            </div>
            <small id="ph_add_streetname-error" class="text-danger input-alert">{{
              errors[0]
            }}</small>
          </ValidationProvider>
          <ValidationProvider rules="required" v-slot="{errors, classes}" class="col-md-6 mb-3">
            <div class="input-group">
              <div class="input-group-prepend dark-border">
                <span class="input-group-text" id="ph_public_space-prepend"
                  ><label for="companyLocationType">Közterület jellege:</label>
                  <span class="text-danger">*</span></span
                >
              </div>
              <input
                type="text"
                class="form-control dark-border"
                id="companyLocationType"
                name="ph_add_streettype"
                v-model="companyLocationType"
                aria-label="Közterület jellege"
                aria-describedby="ph_add_streettype-prepend"
                :class="classes"
              />
            </div>
            <small id="ph_add_streettype-error" class="text-danger input-alert">{{
              errors[0]
            }}</small>
          </ValidationProvider>
        </div>
        <div class="row">
          <ValidationProvider rules="required" v-slot="{errors, classes}" class="col-md-6 mb-3">
            <div class="input-group">
              <div class="input-group-prepend dark-border">
                <span class="input-group-text" id="ph_add_streetno-prepend"
                  ><label for="companyLocationHouseNumber">Házszám:</label>
                  <span class="text-danger">*</span></span
                >
              </div>
              <input
                type="text"
                class="form-control dark-border"
                id="companyLocationHouseNumber"
                name="ph_add_streetno"
                v-model="companyLocationHouseNumber"
                aria-label="Házszám"
                aria-describedby="ph_add_streetno-prepend"
                :class="classes"
              />
            </div>
            <small id="ph_add_streetno-error" class="text-danger input-alert">{{
              errors[0]
            }}</small>
          </ValidationProvider>
          <div class="col-md-6 mb-3">
            <div class="input-group">
              <div class="input-group-prepend dark-border">
                <span class="input-group-text" id="ph_add_other-prepend"
                  ><label for="ph_floar">Épület, emelet, ajtó:</label></span
                >
              </div>
              <input
                type="text"
                class="form-control dark-border"
                id="ph_add_other"
                name="ph_add_other"
                v-model="companyLocationBuilding"
                aria-label="Épület, emelet, ajtó"
                aria-describedby="ph_add_other-prepend"
              />
            </div>
            <small id="ph_add_other-error" class="text-danger input-alert"></small>
          </div>
        </div>
      </div>
    </div>

    <div class="form-group row mb-3">
      <h1 class="h2 mt-4">Levelezési cím</h1>
      <fieldset class="row mb-3">
        <legend style="font-size: 14px; font-weight: bold" class="col-sm-4">
          {{ mailingAddresName }}
        </legend>
        <div class="col-sm-8">
          <div class="form-check">
            <input
              class="form-check-input"
              type="radio"
              name="ph_corraddress_is_same"
              id="ph_corraddress_is_same_igen"
              :value="1"
              v-model="postAddressIsTheSame"
            />
            <label class="form-check-label" for="ph_corraddress_is_same_igen">
              Igen
            </label>
          </div>
          <div class="form-check">
            <input
              class="form-check-input"
              type="radio"
              name="ph_corraddress_is_same"
              id="ph_corraddress_is_same_nem"
              :value="0"
              v-model="postAddressIsTheSame"
            />
            <label class="form-check-label" for="ph_corraddress_is_same_nem">
              Nem
            </label>
          </div>
        </div>
      </fieldset>
    </div>
    <div v-if="!postAddressIsTheSame">
      <div class="row">
        <ValidationProvider
          rules="required|zipcode"
          v-slot="{errors, classes}"
          class="col-md-6 mb-3"
        >
          <div class="input-group">
            <div class="input-group-prepend dark-border">
              <span class="input-group-text" id="ph_corr_zip-prepend"
                ><label for="ph_corr_zip">Irányítószám:</label>
                <span class="text-danger">*</span></span
              >
            </div>
            <input
              type="number"
              class="form-control"
              id="ph_corr_zip"
              name="ph_corr_zip"
              :value="propertyZip"
              aria-label="Irányítószám"
              aria-describedby="ph_corr_zip-prepend"
              :class="classes"
              v-if="postAddressIsTheSame"
            />

            <div class="flex-grow-1" v-else>
              <!-- <Select2
                id="ph_corr_zip"
                name="ph_corr_zip"
                v-model="contractorLocationZip"
                :options="zipCodes"
                :settings="{ selectionCssClass: 'w-full' }"
              /> -->
              <input
                type="text"
                id="ph_corr_zip"
                name="ph_corr_zip"
                v-model="contractorLocationZip"
                class="form-control dark-border"
              />
            </div>
          </div>
          <small id="ph_corr_zip-error" class="text-danger input-alert">{{ errors[0] }}</small>
        </ValidationProvider>
        <div class="col-md-6 mb-3">
          <div class="input-group">
            <div class="input-group-prepend dark-border">
              <label class="input-group-text" id="ph_corr_city-prepend" for="ph_corr_city"
                >Település neve: <span class="text-danger">*</span></label
              >
            </div>
            <input
              type="text"
              class="form-control"
              id="ph_corr_city"
              name="ph_corr_city"
              :value="propertyName"
              aria-label="Település neve"
              aria-describedby="ph_corr_city-prepend"
              v-if="postAddressIsTheSame"
            />

            <template v-else>
              <div class="flex-grow-1" v-if="mailingCityNames.length > 1">
                <select
                  id="ph_corr_city"
                  name="ph_corr_city"
                  v-model="contractorSelectedLocationName"
                  class="form-select dark-border"
                >
                  <option v-for="(city, key) in mailingCityNames" :key="key" :value="city">{{
                    city
                  }}</option>
                </select>
                <!-- <Select2
                  name="ph_corr_city"
                  v-model="contractorSelectedLocationName"
                  :options="mailingCityNames"
                  :settings="{ selectionCssClass: 'w-full' }"
                /> -->
              </div>

              <input
                v-else
                id="ph_corr_city"
                type="text"
                class="form-control dark-border"
                readonly
                name="ph_corr_city"
                :value="contractorSelectedLocationName"
              />
            </template>
          </div>
          <ValidationProvider rules="required" v-slot="{errors}" class="col-md-6 mb-3">
            <input v-show="false" :value="contractorSelectedLocationName" />
            <small id="ph_corr_city-error" class="text-danger input-alert">{{ errors[0] }}</small>
          </ValidationProvider>
        </div>
      </div>
      <div class="row">
        <ValidationProvider rules="required" v-slot="{errors, classes}" class="col-md-6 mb-3">
          <div class="input-group">
            <div class="input-group-prepend dark-border">
              <label
                class="input-group-text"
                id="ph_corr_add_streetname-prepend"
                for="ph_corr_add_streetname"
                >Közterület neve: <span class="text-danger">*</span></label
              >
            </div>
            <input
              type="text"
              class="form-control dark-border"
              id="ph_corr_add_streetname"
              name="ph_corr_add_streetname"
              :value="locationName"
              aria-label="Közterület neve"
              aria-describedby="ph_corr_add_streetname-prepend"
              :class="classes"
              v-if="postAddressIsTheSame"
            />
            <input
              type="text"
              class="form-control dark-border"
              id="ph_corr_add_streetname"
              name="ph_corr_add_streetname"
              v-model="contractorLocationName"
              aria-label="Közterület neve"
              aria-describedby="ph_corr_add_streetname-prepend"
              :class="classes"
              v-else
            />
          </div>
          <small id="ph_corr_add_streetname-error" class="text-danger input-alert">{{
            errors[0]
          }}</small>
        </ValidationProvider>
        <ValidationProvider rules="required" v-slot="{errors, classes}" class="col-md-6 mb-3">
          <div class="input-group">
            <div class="input-group-prepend dark-border">
              <label
                class="input-group-text"
                id="ph_corr_add_streettype-prepend"
                for="ph_corr_add_streettype"
                >Közterület jellege: <span class="text-danger">*</span></label
              >
            </div>
            <input
              type="text"
              class="form-control dark-border"
              id="ph_corr_add_streettype"
              name="ph_corr_add_streettype"
              :value="locationType"
              aria-label="Közterület jellege"
              aria-describedby="ph_corr_add_streettype-prepend"
              :class="classes"
              v-if="postAddressIsTheSame"
            />
            <input
              type="text"
              class="form-control dark-border"
              id="ph_corr_add_streettype"
              name="ph_corr_add_streettype"
              v-model="contractorLocationType"
              aria-label="Közterület jellege"
              aria-describedby="ph_corr_add_streettype-prepend"
              :class="classes"
              v-else
            />
          </div>
          <small id="ph_corr_add_streettype-error" class="text-danger input-alert">{{
            errors[0]
          }}</small>
        </ValidationProvider>
      </div>
      <div class="row">
        <ValidationProvider rules="required" v-slot="{errors, classes}" class="col-md-6 mb-3">
          <div class="input-group">
            <div class="input-group-prepend dark-border">
              <label
                class="input-group-text"
                id="ph_corr_add_streetno-prepend"
                for="ph_corr_add_streetno"
                >Házszám: <span class="text-danger">*</span></label
              >
            </div>
            <input
              type="text"
              class="form-control dark-border"
              id="ph_corr_add_streetno"
              name="ph_corr_add_streetno"
              :value="locationHouseNumber"
              aria-label="Házszám"
              aria-describedby="ph_corr_add_streetno-prepend"
              :class="classes"
              v-if="postAddressIsTheSame"
            />
            <input
              type="text"
              class="form-control dark-border"
              id="ph_corr_add_streetno"
              name="ph_corr_add_streetno"
              v-model="contractorLocationHouseNumber"
              aria-label="Házszám"
              aria-describedby="ph_corr_add_streetno-prepend"
              :class="classes"
              v-else
            />
          </div>
          <small id="ph_corr_add_streetno-error" class="text-danger input-alert">{{
            errors[0]
          }}</small>
        </ValidationProvider>
        <div class="col-md-6 mb-3">
          <div class="input-group">
            <div class="input-group-prepend dark-border">
              <label class="input-group-text" id="ph_corr_add_other-prepend" for="ph_corr_add_other"
                >Épület, emelet, ajtó:</label
              >
            </div>
            <input
              type="text"
              class="form-control dark-border"
              id="ph_corr_add_other"
              name="ph_corr_add_other"
              :value="locationBuilding"
              aria-label="Épület, emelet, ajtó"
              aria-describedby="ph_corr_add_other-prepend"
              v-if="postAddressIsTheSame"
            />
            <input
              type="text"
              class="form-control dark-border"
              id="ph_corr_add_other"
              name="ph_corr_add_other"
              v-model="contractorLocationBuilding"
              aria-label="Épület, emelet, ajtó"
              aria-describedby="ph_corr_add_other-prepend"
              v-else
            />
          </div>
          <small id="ph_corr_add_other-error" class="text-danger input-alert"></small>
        </div>
      </div>
    </div>
    <div class="form-group row mb-3">
      <label class="col-sm-4"
        >Szeretné, ha a Biztosító (postai levelezés helyett) elektronikus formában kommunikálna
        Önnel? <span class="text-danger">*</span>
        <button
          class="info border border-white"
          id="elektronikus_kommunikacio-tooltip"
          data-toggle="tooltip"
          data-placement="right"
          title=""
          type="button"
        >
          ?
        </button>
      </label>
      <div class="col-sm-8">
        <div class="form-check">
          <input
            class="form-check-input"
            type="radio"
            name="ekommunikacio"
            id="e_kommunikacio_igen"
            :value="1"
            v-model="electronicContact"
          />
          <label class="form-check-label" for="e_kommunikacio_igen">
            Igen
          </label>
        </div>
        <div class="form-check">
          <input
            class="form-check-input"
            type="radio"
            name="ekommunikacio"
            id="e_kommunikacio_nem"
            :value="0"
            v-model="electronicContact"
          />
          <label class="form-check-label" for="e_kommunikacio_nem">
            Nem
          </label>
        </div>
        <!-- <small class="text-danger"
          >Elektronikus kommunikáció választásakor további -5% kedvezményt adunk az éves
          díjból.</small
        ><br /> -->
        <!-- <span v-if="!electronicContact"
          ><small class="text-warning fw-bold input-alert">
            Ebben az esetben az összes dokumentumot kinyomtatjuk és postán is küldjük Önnek. Ez egy
            sokkal lassabb és környezetszennyezőbb folyamat, valamint így nem takarít meg 5%-ot a
            végső árból. </small
          ><br
        /></span> -->
        <small id="elektronikus_kommunikacio-error" class="text-danger input-alert"></small>
      </div>
    </div>
    <h1 class="h2 mt-4">Kockázatviselés kezdete</h1>
    <div class="form-group row mb-2">
      <label class="col-sm-4" for="begin_date"
        >Kockázatviselés kezdete: <span class="text-danger">*</span></label
      >
      <div class="col-sm-8">
        <input
          id="begin_date"
          autocomplete="off"
          class="form-control dark-border"
          type="date"
          name="begin_date"
          :min="riskStartMinDate"
          :max="riskStartMaxDate"
          v-model="startDate"
          required
        />
        <!-- <Datepicker
          id="begin_date"
          name="begin_date"
          :format="'yyyy-MM-dd'"
          :placeholder="'ÉÉÉÉ-HH-NN'"
          :language="hu"
          :disabled-dates="riskStartDisabledDates"
          :typeable="false"
          input-class="form-control"
          required
          v-model="startDate"
        ></Datepicker> -->
        <ValidationProvider :immediate="true" rules="required|kockazat_kezdet" v-slot="{errors}">
          <input type="text" name="begin_date" :value="startDate" disabled hidden />
          <small class="text-danger input-alert">{{ errors[0] }}</small>
        </ValidationProvider>
      </div>
    </div>
    <div class="row">
      <h1 class="h2 col-sm-4 ">Díjfizetés</h1>
      <div class="h2 col-sm-8" style="color: #B0001F">
        A díjfizetési linket jelen csatlakozási nyilatkozat megtételét követő napon, a
        fedezetigazolással együtt küldjük email-ben.
      </div>
    </div>
    <div class="form-group row mb-3">
      <div class="col-sm-4">
        <b
          >Díjfizetési mód <span class="text-danger">*</span>
          <button
            class="info border border-white"
            id="payment_way-tooltip"
            data-toggle="tooltip"
            data-placement="right"
            title=""
            type="button"
          >
            ?
          </button></b
        >
      </div>
      <div class="col-sm-8 row">
        <input type="text" hidden v-model="paymentType" name="payment_way" />
        <div class="col-md-4 form-group mb-2">
          <button
            type="button"
            class="btn w-100 h-100 d-flex align-items-center justify-content-center"
            @click="paymentType = 'online'"
            :class="{
              'btn-red': paymentType == 'online',
              'btn-outline-danger': paymentType !== 'online',
            }"
          >
            Online bankkártyás fizetés
          </button>
        </div>
        <!-- Ez még kellhet -->
        <!-- <div class="col-md-4 form-group mb-2">
            <div
              class="btn w-100 h-100 d-flex align-items-center justify-content-center"
              @click="paymentType = 'atutalas'"
              :class="{
                'btn-red': paymentType == 'atutalas',
                'btn-outline-danger': paymentType !== 'atutalas',
              }"
            >
              Átutalás
            </div>
          </div> -->
      </div>
      <small id="payment_way-error" class="text-danger input-alert"></small>
    </div>
    <div class="form-group row mb-3">
      <div class="col-sm-4">
        <b
          >Díjfizetési gyakoriság
          <span class="text-danger">*</span>
          <button
            class="info border border-white"
            id="payment_frequency-tooltip"
            data-toggle="tooltip"
            data-placement="right"
            title=""
            type="button"
          >
            ?
          </button></b
        >
      </div>
      <div class="col-sm-8 row">
        <input type="text" hidden v-model="paymentFrequency" name="payment_frequency" />
        <div class="col-md-4 form-group mb-2">
          <button
            type="button"
            class="btn w-100 h-100 d-flex align-items-center justify-content-center"
            @click="paymentFrequency = 'eves'"
            :class="{
              'btn-red': paymentFrequency == 'eves',
              'btn-outline-danger': paymentFrequency !== 'eves',
            }"
          >
            Éves
          </button>
        </div>
        <!-- Ez még kellhet! -->
        <!-- <div class="col-md-4 form-group mb-2">
            <div
              class="btn w-100 h-100 d-flex align-items-center justify-content-center"
              @click="paymentFrequency = 'negyedeves'"
              :class="{
                'btn-red': paymentFrequency == 'negyedeves',
                'btn-outline-danger': paymentFrequency !== 'negyedeves',
              }"
            >
              Negyedéves
            </div>
          </div> -->
      </div>
      <small id="payment_frequency-error" class="text-danger input-alert"></small>
    </div>
    <div v-show="false" class="form-group row mb-3">
      <label class="col-sm-4">Ki köti a biztosítást? <span class="text-danger">*</span></label>
      <div class="col-sm-8">
        <div class="row">
          <input type="text" hidden name="is_agent" :value="0" v-if="isAgent == 0" />
          <input type="text" hidden name="is_agent" :value="1" v-else-if="isAgent == 2" />
          <div class="col-md-4 form-group mb-2">
            <div
              class="btn w-100"
              @click="isAgent = 0"
              :class="{'btn-red': isAgent == 0, 'btn-outline-danger': isAgent !== 0}"
            >
              Ügyfél
            </div>
          </div>
          <div class="col-md-4 form-group mb-2">
            <div
              class="btn w-100"
              @click="isAgent = 1"
              :class="{'btn-red': isAgent == 1, 'btn-outline-danger': isAgent !== 1}"
            >
              Értékesítő
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="form-group row">
      <div class="input-group">
        <label class="col-sm-4" for="agent_id"
          >Értékesítő azonosító:
          <button
            class="info border border-white"
            id="agent_id-tooltip"
            data-toggle="tooltip"
            data-placement="right"
            title=""
            type="button"
          >
            ?
          </button></label
        >
        <input class="form-control dark-border" id="agent_id" name="agent_id" v-model="agentId" />
      </div>
    </div>
  </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker';
import {mapFields} from 'vuex-map-fields';
import {hu} from 'vuejs-datepicker/dist/locale';
import Select2 from 'v-select2-component';
import moment from 'moment';

export default {
  components: {
    Datepicker,
    Select2,
  },
  data() {
    const now = new Date();
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 1);
    const minDate = new Date();
    minDate.setFullYear(1900);
    minDate.setMonth(1);
    minDate.setDate(1);
    const maxDate = new Date();
    maxDate.setFullYear(today.getFullYear() - 18);
    maxDate.setMonth(now.getMonth());
    maxDate.setDate(now.getDate());

    const minDateIns = new Date();
    minDateIns.setFullYear(today.getFullYear() - 80);
    minDateIns.setMonth(1);
    minDateIns.setDate(1);
    const maxDateIns = new Date();
    maxDateIns.setFullYear(today.getFullYear() - 12);
    maxDateIns.setMonth(now.getMonth());
    maxDateIns.setDate(now.getDate());
    const birthMinDate = moment(minDate).format('YYYY-MM-DD');
    const birthMaxDate = moment(maxDate).format('YYYY-MM-DD');
    const riskStartMinDate = moment(new Date(new Date().setDate(now.getDate() + 1))).format(
      'YYYY-MM-DD'
    );
    const riskStartMaxDate = moment(new Date(new Date().setDate(now.getDate() + 180))).format(
      'YYYY-MM-DD'
    );
    const birthMinDateIns = moment(minDateIns).format('YYYY-MM-DD');
    const birthMaxDateIns = moment(maxDateIns).format('YYYY-MM-DD');
    const biztMinDate = moment(minDate).format('YYYY-MM-DD');
    const biztMaxDate = moment(new Date()).format('YYYY-MM-DD');

    return {
      hu: hu,
      yearlyDefaultPrice: 0,
      accessorySumPrice: 0,
      discountPrice: 0,
      frequencyPrice: 0,
      mortgageBank: null,
      bornInitialDate: maxDate,
      cityNames: [],
      companyCityNames: [],
      mailingCityNames: [],
      riskStartDisabledDates: {
        customPredictor: function(date) {
          const maxDate = new Date().setDate(now.getDate() + 180);
          return date < now || date > maxDate;
        },
      },
      bornDisabledDatesIns: {
        customPredictor: function(date) {
          return date > maxDateIns || date < minDateIns;
        },
      },
      bornDisabledDates: {
        customPredictor: function(date) {
          return date > maxDate || date < minDate;
        },
      },
      biztDisabledDates: {
        customPredictor: function(date) {
          return date > today || date < minDate;
        },
      },
      birthMinDate,
      birthMaxDate,
      riskStartMinDate,
      riskStartMaxDate,
      birthMinDateIns,
      birthMaxDateIns,
    };
  },
  computed: {
    ...mapFields([
      'cities',
      'merchant_id',
      'contractorPropertyZipChanged',

      'generalInfo.privatePerson',
      'generalInfo.contractorVat',
      'generalInfo.contractFor',
      'riskSettings.startDate',
      'generalInfo.propertyZip',
      'generalInfo.propertyName',
      'generalInfo.selectedPropertyName',
      'generalInfo.isAgent',
      'generalInfo.agentId',
      'riskSettings.locationZip',
      'riskSettings.locationCity',
      'riskSettings.locationName',
      'riskSettings.locationType',
      'riskSettings.locationHouseNumber',
      'riskSettings.locationBuilding',
      'riskSettings.locationTopography',

      'riskSettings.companyLocationZip',
      'riskSettings.companyLocationCity',
      'riskSettings.companyLocationName',
      'riskSettings.companyLocationType',
      'riskSettings.companyLocationHouseNumber',
      'riskSettings.companyLocationBuilding',

      'electronicContact',

      'contractSettings.emailVerified',
      'contractSettings.postAddressIsTheSame',
      'insuredSettings.contractedIsInsured',
      'mortgageSettings.propertyIsMortgaged',

      'statementSettings.privacyStatement',
      'statementSettings.insuranceTerms',
      'statementSettings.electronicCommunation',
      'statementSettings.marketingMails',

      'banks',
    ]),
    ...mapFields({
      contractorGender: 'contractSettings.gender',
      contractorLastName: 'contractSettings.lastName',
      contractorCompanyName: 'contractSettings.companyName',
      contractorFirstName: 'contractSettings.firstName',
      contractorMotherChildName: 'contractSettings.motherChildName',
      contractorBornName: 'contractSettings.bornName',
      contractorBornCity: 'contractSettings.bornCity',
      contractorBornDate: 'contractSettings.bornDate',
      contractorPhoneNumberArea: 'contractSettings.phoneNumberArea',
      contractorPhoneNumber: 'contractSettings.phoneNumber',
      contractorEmail: 'contractSettings.email',
      contractorEmailVerification: 'contractSettings.emailVerification',

      contractorLocationZip: 'contractSettings.postAddress.locationZip',
      contractorLocationCity: 'contractSettings.postAddress.locationCity',
      contractorLocationName: 'contractSettings.postAddress.locationName',
      contractorSelectedLocationName: 'contractSettings.postAddress.selectedLocationName',
      contractorLocationType: 'contractSettings.postAddress.locationType',
      contractorLocationHouseNumber: 'contractSettings.postAddress.locationHouseNumber',
      contractorLocationBuilding: 'contractSettings.postAddress.locationBuilding',
      contractorLocationTopography: 'contractSettings.postAddress.locationTopography',

      insuredGender: 'insuredSettings.gender',
      insuredLastName: 'insuredSettings.lastName',
      insuredFirstName: 'insuredSettings.firstName',
      insuredMotherChildName: 'insuredSettings.motherChildName',
      insuredBornName: 'insuredSettings.bornName',
      insuredBornCity: 'insuredSettings.bornCity',
      insuredBornDate: 'insuredSettings.bornDate',
      insuredPhoneNumberArea: 'insuredSettings.phoneNumberArea',
      insuredPhoneNumber: 'insuredSettings.phoneNumber',
      insuredEmail: 'insuredSettings.email',
      insuredEmailVerification: 'insuredSettings.emailVerification',
      paymentType: 'paymentOptions.type',
      paymentFrequency: 'paymentOptions.frequency',
    }),
    zipCodes: {
      get() {
        return Object.keys(this.cities);
      },
    },
    mailingAddresName: {
      get() {
        if (this.merchant_id === 'nsu') return 'A levelezési címe megegyezik a lakcímével?';
        if (this.privatePerson && this.contractedIsInsured && this.merchant_id !== 'nsu')
          return 'A levelezési címe megegyezik a biztosított lakcímével?';
        if (this.privatePerson && !this.contractedIsInsured)
          return 'A levelezési címe megegyezik a szerződő címével?';
        else return 'A levelezési címe megyezik a székhely címével?';
      },
    },
    contractorNameText: function() {
      if (this.merchant_id == 'nsu') return 'Csatlakozási nyilatkozatot tevő';
      else return 'szerződő';
    },
    nsuMiner() {
      return !(this.merchant_id === 'nsu' && this.getAge(this.insuredBornDate) < 18);
    },
  },
  methods: {
    getCityNamesByZip: function(zip) {
      const zipCodeList = Object.keys(this.cities);
      if (zipCodeList.length === 0 || (zipCodeList.length > 0 && !zipCodeList.includes(zip)))
        return [];

      const zipData = this.cities[zip];

      if (!zipData) return [];

      return typeof zipData.telepules === 'string'
        ? [zipData.telepules]
        : Object.values(zipData.telepules);
    },

    getAge(birthDate) {
      var today = new Date();
      const birthDateAsDate = new Date(birthDate);
      var age = today.getFullYear() - birthDateAsDate.getFullYear();
      var m = today.getMonth() - birthDateAsDate.getMonth();
      if (m < 0 || (m === 0 && today.getDate() < birthDateAsDate.getDate())) {
        age--;
      }
      return age;
    },
  },

  watch: {
    contractorPhoneNumberArea: function(newVal) {
      if (newVal > 99) this.contractorPhoneNumberArea = 99;
      if (newVal < 0) this.contractorPhoneNumberArea = 1;
    },
    insuredPhoneNumberArea: function(newVal) {
      if (newVal > 99) this.insuredPhoneNumberArea = 99;
      if (newVal < 0) this.insuredPhoneNumberArea = 1;
    },
    mortgageBank: function(newVal, oldVal) {
      const bank = this.banks.find((bank) => bank.id === newVal);
      if (bank) {
        this.mortgageCreditor = bank.name;
        this.mortgageCreditorLocation = bank.address;
      } else {
        if (newVal == '0000000000') {
          //
        } else {
          this.mortgageBank = null;
        }
        this.mortgageCreditor = '';
        this.mortgageCreditorLocation = '';
      }
    },
    locationZip: function(newVal) {
      this.cityNames = this.getCityNamesByZip(newVal);

      if (this.cityNames.length === 1) {
        this.locationCity = this.cityNames[0];
      }
    },
    companyLocationZip: function(newVal) {
      this.companyCityNames = this.getCityNamesByZip(newVal);

      if (this.companyCityNames.length === 1) {
        this.companyLocationCity = this.companyCityNames[0];
      }
    },
    contractorLocationZip: function(newVal) {
      this.mailingCityNames = this.getCityNamesByZip(newVal);

      if (this.mailingCityNames.length === 1) {
        this.contractorSelectedLocationName = this.mailingCityNames[0];
      }
    },

    paymentFrequency: function(value) {
      if (value == 'havi' && !this.canChooseMonthlyPayment) this.paymentFrequency = 'negyedeves';
    },
    contractedIsInsured: function(value) {
      if (value == 1) {
        this.privatePerson = 1;
        this.companyLocationZip = '';
        this.companyLocationCity = '';
        this.companyLocationName = '';
        this.companyLocationType = '';
        this.companyLocationHouseNumber = '';
        this.companyLocationBuilding = '';
      } else {
        this.locationZip = '';
        this.locationCity = '';
        this.locationName = '';
        this.locationType = '';
        this.locationHouseNumber = '';
        this.locationBuilding = '';
      }
    },
    contractorBornDate: function(newVal) {
      this.$store.dispatch('verifyPage');
    },
    insuredBornDate: function(newVal) {
      this.$store.dispatch('verifyPage');
      if (this.getAge(newVal) < 18) {
        this.contractedIsInsured = 0;
      }
    },
    isAgent: function() {
      if (this.isAgent === 0)
        this.$store.commit('setGeneralPropertyValues', {
          name: 'agentId',
          value: '',
        });
    },
    agentId: function(value) {
      if (value == '') this.isAgent = 0;
      else this.isAgent = 2;
    },
    insuredBornDate: function(date) {
      if (this.getAge(date) <= 18) this.contractedIsInsured = 0;
      else this.contractedIsInsured = 1;
    },
  },
};
</script>

<style lang="scss" scoped>
.form-check-label {
  font-size: 20px;
  line-height: 24px;
}

.text-danger {
  color: #b0001f !important;
}

.custom-file-label::after {
  content: 'Kiválasztás' !important;
}

.select2-selection__rendered {
  line-height: 38px !important;
}
.select2-container .select2-selection--single {
  height: 38px !important;
  border-color: #66889b;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.select2-selection__arrow {
  height: 38px !important;
}
</style>
